import { createFileRoute } from "@tanstack/react-router";
import { HijriYearPage } from "@/components/pages/HijriYearPage";
import { currentHijriYear } from "@/lib/calendar/hijri";

export const Route = createFileRoute("/kalender-hijriah/")({ 
  loader: () => ({ hYear: currentHijriYear() }),
  head: ({ loaderData }) => {
    const y = loaderData?.hYear ?? new Date().getFullYear();
    const title = `Kalender Hijriah ${y} H - Kalender Islam Indonesia`;
    const desc = `Kalender Islam (Hijriah) ${y} H lengkap dengan tanggal Masehi, hari libur nasional Indonesia, dan hari penting Islam (Ramadhan, Idul Fitri, Idul Adha).`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
      ],
    };
  },
  component: () => {
    const { hYear } = Route.useLoaderData();
    return <HijriYearPage hYear={hYear} />;
  },
});